import React from 'react';
import PropTypes from 'prop-types';
import GenericEvaluationComponent from './GenericEvaluationComponent';

const GenericEvaluationCard = ({
  evaluatingExpression,
  evaluationParameters,
  evaluationResult,
  genericEvaluationEntities,
  onGenericEvaluationParameterChanged,
  onEvaluateGenericExpression,
  localEvaluationEntity,
  handleOpenModal,
  handleCloseModal,
  modalOpen,
  handleCopyToClipboard
}) => {
  return (
    <GenericEvaluationComponent
      evaluatingExpression={evaluatingExpression}
      evaluationParameters={evaluationParameters}
      evaluationResult={evaluationResult}
      genericEvaluationEntities={genericEvaluationEntities}
      onEvaluateGenericExpression={onEvaluateGenericExpression}
      onGenericEvaluationParameterChanged={onGenericEvaluationParameterChanged}
      localEvaluationEntity={localEvaluationEntity}
      modalOpen={modalOpen}
      handleCloseModal={handleCloseModal}
      handleOpenModal={handleOpenModal}
      handleCopyToClipboard={handleCopyToClipboard}
    />
  );
};

GenericEvaluationCard.propTypes = {
  evaluatingExpression: PropTypes.bool.isRequired,
  evaluationParameters: PropTypes.object.isRequired,
  evaluationResult: PropTypes.object,
  genericEvaluationEntities: PropTypes.array.isRequired,
  onGenericEvaluationParameterChanged: PropTypes.func.isRequired,
  onEvaluateGenericExpression: PropTypes.func.isRequired,
  localEvaluationEntity: PropTypes.object.isRequired,
  handleOpenModal: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  handleCopyToClipboard: PropTypes.func.isRequired
};

export default GenericEvaluationCard;
